<template>
		<MainLayout>
			<div class="container">
				<div class="box">
					<b-button class="float-right" @click="() => newUser()" >{{$t('serviceType.new')}}</b-button>
					<h2>{{$t('serviceType.module')}}</h2>
					<hr>
					<b-form @submit="(evt) => { evt.preventDefault(); this.$root.$emit('bv::refresh::table', 'service-types-index-list') } ">
						<div class="row">
							<b-form-group class="col-md-2" :label="$t('global.search')">
								<b-form-input v-model="filters.search" type="text" />
							</b-form-group>
							<b-form-group class="col" label=".">
								<b-button type="submit" variant="primary">{{$t('global.search')}}</b-button>
							</b-form-group>
						</div>
					</b-form>
					<AjaxTable
						id="service-types-index-list"
						:filters="filters"
						:columns="columns"
						resource="crud/service-types"
					>
						<template v-slot:cell(actions)="row">
							<div class="text-center">
								<b-button @click="(event) => modelView(row.item,row.index,event)" type="button" size="sm" class="mr-1" variant="info">
									<md-icon icon="edit" />
								</b-button>
								<b-button @click="(event) => modelDelete(row.item,row.index,event)" type="button" size="sm" class="mr-1" variant="danger">
									<md-icon icon="delete" />
								</b-button>
							</div>
						</template>
					</AjaxTable>
				</div>
			</div>
			<Single ref="single" :success-callback="successCallback" />
		</MainLayout>
</template>

<script>
import MainLayout from '../layout/MainLayout.vue'
import AjaxTable from '../../helpers/AjaxTable.vue'
import Single from './Single.vue'

export default {
		components: { MainLayout, Single, AjaxTable },
		data(){
				return {
					modalInfo : {
						modelId:-1,
					},
					filters : {
						search:'',
					},
					columns : [
						{key:'id',label:'ID'},
						{key:'name',label:this.$t('serviceType.name')},
						{key:'code',label:this.$t('serviceType.code')},
						{key:'maxPax',label:this.$t('serviceType.maxPax')},
						{key:'maxSuitecases',label:this.$t('serviceType.maxSuiteCases')},
						{key:'serviceTypeCategory.code',label:this.$t('serviceType.category')},
						{key:'description',label:this.$t('serviceType.description')},
						{key:'serviceType',label:this.$t('serviceType.serviceType')},
						{key:'status',label:this.$t('global.status')},
						{key:'actions',label:this.$t('global.actions')},
					],
				}
		},
		methods:{
			successCallback(){
				this.$root.$emit('bv::refresh::table', 'service-types-index-list')
			},
			modelView(item){
				this.$refs['single'].loadModel(item.id)
			},
			newUser(accessType){
				this.$refs['single'].loadModel(-1)
				if (accessType) {
					this.$refs['single'].setAccessType(accessType)
				}
			},
			modelDelete(item){
				this.$bvModal
				.msgBoxConfirm(this.$t("serviceType.confirmDelete",{serviceType:item.name}), {
					title: this.$t("warnings.okToContinue"),
					size: "md",
					buttonSize: "md",
					okVariant: "danger",
					okTitle: this.$t("global.yes")+", "+this.$t("warnings.continue"),
					cancelTitle: "Cancel",
					footerClass: "p-2",
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value === true) {
						this.$root.api.delete(`/service-types/${item.id}`).then(() => {
							this.$root.showAlert(this.$t('global.registerDeleted'),{variant:'success'})
							this.successCallback();
							close()
						}).catch( err => {
							this.$root.handleRequestError(err)
							close()
						});
					}
				})
				.catch(err => {
					console.log(err);
					// An error occurred
				});
			}
		},
		mounted(){
		}
}
</script>

<style>

</style>
